import { usePathname } from 'next/navigation';

import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';
import { getRootFromPath } from '@core/Utils/Search/GetRootFromPath';

//NOTE: this should only be used on a listing page (used, new)
// otherwise it will return false info
const useGetRoot = (): PlpRoot => {
  const pathname = usePathname();

  return getRootFromPath(pathname);
};

export { useGetRoot };
